import { useState, useEffect } from 'react';
import apiService from '../services/api';

/**
 * Hook centralisé pour récupérer l'utilisateur actuel depuis localStorage
 * @returns {object} { user, role, commercantId, isSuperAdmin, isAdmin, isCommercant, loading }
 */
export const useCurrentUser = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const storedUser = apiService.getStoredUser();
      
      // Si pas d'utilisateur dans la nouvelle clé, essayer l'ancienne clé (legacy)
      if (!storedUser) {
        const legacyUserData = localStorage.getItem('admin_user');
        if (legacyUserData) {
          try {
            const parsed = JSON.parse(legacyUserData);
            setUser(parsed);
          } catch (error) {
            console.error('Erreur parsing user data:', error);
            setUser(null);
          }
        } else {
          setUser(null);
        }
      } else {
        setUser(storedUser);
      }
    } catch (error) {
      console.error('Erreur récupération utilisateur:', error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  // Normaliser le rôle
  const normalizedRole = user?.role === 'super-admin' ? 'SUPER_ADMIN' : user?.role;

  return {
    user,
    role: normalizedRole || null,
    commercantId: user?.commercantId || user?.commercant?.id || null,
    isSuperAdmin: normalizedRole === 'SUPER_ADMIN',
    isAdmin: normalizedRole === 'ADMIN' || normalizedRole === 'SUPER_ADMIN',
    isCommercant: normalizedRole === 'COMMERCANT',
    loading
  };
};

export default useCurrentUser;







